import React from 'react';
import { Icon } from '../../Icon';
const avatarSizeToIconSize = {
    '2xs': 12,
    xs: 14,
    s: 16,
    m: 16,
    l: 20,
    xl: 24,
};
export const AvatarIcon = ({ icon, color, size, className }) => {
    const style = { color };
    return (React.createElement("div", { style: style, className: className },
        React.createElement(Icon, { data: icon, size: avatarSizeToIconSize[size] })));
};
